<template>
  <div class="nav-widget">
    <a
      v-if="externalTypeOfLink"
      class="nav-widget__title"
      :href="url.path ? url.path : '#'"
      rel="noopener noreferrer"
      target="_blank"
      @click="$emit('closeMenu')"
    >
      <span v-html="title"></span>
    </a>
    <nuxt-link
      v-else
      class="nav-widget__title"
      :to="{
        path: localePath(url.path ? `${url.path}` : ''),
        hash: url.hash ? `${url.hash}` : ''
      }"
      @click.native="$emit('closeMenu')"
    >
      <span v-html="title"></span>
    </nuxt-link>
    <div class="nav-widget__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuWidget',
  props: {
    title: {
      type: String,
      default: ''
    },
    externalTypeOfLink: {
      type: Boolean,
      default: false
    },
    url: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
.nav-widget {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 12px 0;
  padding: 16px 0;
  background-color: #FFF;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1),
  0 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 10px;

  @media (max-width: $breakpoint-xl) {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}

.nav-widget__title,
.nav-widget__inner {
  padding: 0 24px;
}

.nav-widget__inner {
  max-width: 100%;
}

.nav-widget__title {
  position: relative;
  margin-bottom: 4px;
  color: inherit;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -1px;
    display: block;
    width: 2px;
    height: 1.5em;
    background-color: $secondary;
    border-radius: 1px;
  }
}

.nav-widget__inner {
  flex-grow: 1;
  display: flex;
}
</style>